<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 182 158"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M55.5534 82.1135L57.0909 84.1987C61.812 90.6011 62.3049 99.2157 58.3452 106.122L34.365 147.945C30.4053 154.851 22.7499 158.729 14.883 157.813L12.3209 157.515C2.38398 156.358 -3.12468 145.33 1.87686 136.607L32.35 83.4596C37.3515 74.7365 49.5901 74.0265 55.5534 82.1135Z"
      fill="url(#abot-logo-gradient-left)"
    />
    <path
      d="M126.373 44.4747L180.101 136.591C185.405 145.685 178.99 157.092 168.387 157.42L165.163 157.52C157.781 157.748 150.869 153.94 147.176 147.608L100.272 67.1916C96.579 60.8597 96.7027 53.0304 100.594 46.8159L102.293 44.1019C107.882 35.1769 121.069 35.381 126.373 44.4747Z"
      fill="url(#abot-logo-gradient-right)"
    />
    <path
      d="M55.2277 44.1672C60.5285 34.7465 73.9882 34.6915 79.3647 44.0686L132.518 136.772C137.894 146.149 131.117 157.859 120.364 157.771L119.458 157.763C118.635 157.917 117.782 158 116.902 158H66.6377C66.5037 158 66.3702 157.996 66.2372 157.993C66.0837 157.997 65.9299 158 65.7755 158C55.3546 158 46.9067 149.494 46.9066 139C46.9066 128.507 55.3545 120 65.7755 120C70.6162 120 75.0304 121.836 78.3706 124.854C79.4586 125.554 80.5827 126.228 81.7592 126.788C83.9959 127.853 86.2289 128.426 88.514 128.028L53.58 67.0969C50.0609 60.9592 50.0302 53.4048 53.4995 47.2385L55.2277 44.1672Z"
      fill="url(#abot-logo-gradient-center)"
    />
    <path
      d="M85.897 36.9911C88.2499 38.7434 90.2105 42.5074 90.6027 44C90.9948 42.5074 92.9555 38.7434 95.3083 36.9911C100.153 33.3831 102.648 33.1903 106.288 28.8142C109.929 24.4381 110.347 16.7434 108.053 11.6814C106.288 7.78761 101.19 0.19469 90.6027 0C80.015 0.19469 74.9172 7.78761 73.1526 11.6814C70.8586 16.7434 71.2766 24.4381 74.9172 28.8142C78.5578 33.1903 81.0523 33.3831 85.897 36.9911Z"
      fill="#F09800"
    />
    <defs>
      <linearGradient
        id="abot-logo-gradient-left"
        x1="30.5032"
        y1="76.4592"
        x2="30.5032"
        y2="157.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#66BB6A" />
        <stop offset="0.5" stop-color="#34A853" />
        <stop offset="1" stop-color="#258B3E" />
      </linearGradient>
      <linearGradient
        id="abot-logo-gradient-right"
        x1="139.793"
        y1="37.5295"
        x2="139.793"
        y2="157.53"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#66BB6A" />
        <stop offset="0.5" stop-color="#34A853" />
        <stop offset="1" stop-color="#258B3E" />
      </linearGradient>
      <linearGradient
        id="abot-logo-gradient-center"
        x1="90.6542"
        y1="37.0686"
        x2="90.6542"
        y2="158"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#66BB6A" />
        <stop offset="0.5" stop-color="#34A853" />
        <stop offset="1" stop-color="#258B3E" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
/** Purpose: Render the bundled Abot brand mark used when no custom Widget logo is available. */
</script>
